import {TOGGLE} from '@drivesally/sally-fw/lib/inputTypes';

// Attribute
import attribute from '@drivesally/sally-fw/lib/attribute/attribute';

export default attribute({
  type: TOGGLE,
  attribute: 'requires_rideshare_inspection',
  label: {
    default: 'Requires RideShare Inspection',
    short: 'RideShare Inspection',
  },
});
